import {
    WithContentfulEditMode,
    ContentfulPageEditButton
} from './with-contentful-edit';

export default WithContentfulEditMode;
export { ContentfulPageEditButton };
